import { useEffect, useRef, useState } from 'react';
import { throttle } from 'lodash';

export function useIsMountedRef() {
  const isMounted = useRef<boolean>(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  });

  return isMounted;
}

export function useScreenSize(mobileBreakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= mobileBreakpoint);

  useEffect(() => {
    const handleResize = throttle(() => {
      setIsMobile(window.innerWidth <= mobileBreakpoint);
    }, 40);

    window.addEventListener('resize', handleResize);
    return () => {
      handleResize.cancel();
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileBreakpoint]);

  return { isMobile };
}
